import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IndosbookMark } from "./IndosbookLogo";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import { MobileReadingProgress } from "./MobileReadingProgress";

const Header = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const goLogin = () => navigate("/login");
  const goSignup = () => navigate("/signup");

  // Clicking the logo always returns to the landing page, scrolled to the very top
  const goHomeTop = () => {
    navigate("/");
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-white/90 backdrop-blur-md border-b border-gray-100">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-14 items-center justify-between">
          {/* Logo */}
          <button onClick={goHomeTop} className="flex shrink-0 items-center gap-2" aria-label="Indosbook home" data-testid="header-logo">
            <IndosbookMark size={28} />
            <span className="font-heading text-xl font-extrabold text-[#0B2D8C]">indosbook</span>
          </button>

          {/* Actions */}
          <div className="hidden sm:flex items-center gap-2 ml-4">
            <Button
              onClick={goLogin}
              variant="ghost"
              className="rounded-full font-bold text-[#FF4500] hover:bg-[#FF4500]/10 hover:text-[#FF4500]"
            >
              Log In
            </Button>
            <Button onClick={goSignup} className="rounded-full bg-[#FF4500] font-bold text-white hover:bg-[#e03d00]">
              Sign Up
            </Button>
          </div>

          {/* Mobile toggle */}
          <button
            className="sm:hidden text-gray-700"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="sm:hidden border-t border-gray-100 bg-white px-4 py-4">
          <div className="flex flex-col gap-3">
            <div className="flex gap-2 pt-1">
              <Button onClick={goLogin} variant="outline" className="flex-1 rounded-full font-bold border-[#FF4500] text-[#FF4500]">
                Log In
              </Button>
              <Button onClick={goSignup} className="flex-1 rounded-full bg-[#FF4500] font-bold text-white hover:bg-[#e03d00]">
                Sign Up
              </Button>
            </div>
          </div>
        </div>
      )}
      <MobileReadingProgress />
    </header>
  );
};

export default Header;
